import moment from 'moment-timezone';

export const shouldShowMessage = ({ startDate, startTime, endDate, endTime }) => {
  let start = moment();
  if (startDate) start = moment(startDate);
  if (startTime) {
    const [hour, minute] = startTime.split(':');
    start.hour(hour).minute(minute);
  }

  let end = moment();
  if (endDate) end = moment(endDate);
  if (endTime) {
    const [hour, minute] = endTime.split(':');
    end.hour(hour).minute(minute);
  }

  return moment().isBetween(start, end, 'minute', '[]');
};

export const formatInAppMessages = (messages) => {
  const messageTypes = {
    Menu: [],
    Receipt: [],
    Loyalty: [],
    ClaimConfirmation: []
  };

  function _checkMessageType(type) {
    return type.inAppMessageType === 'Menu' || type.inAppMessageType === 'Receipt' || type.inAppMessageType === 'Loyalty' || type.inAppMessageType === 'ClaimConfirmation';
  }

  function _reduceMessageTypes(curr, next) {
    const typeMatch = _checkMessageType(next);

    if (typeMatch) curr[next.inAppMessageType].push(next);

    return curr;
  }

  const result = messages.reduce(_reduceMessageTypes, messageTypes);

  return result;
};

export const filterInAppMessages = (inAppMessagesByType, seenMessage) => {
  const filteredMessagesForType = inAppMessagesByType[seenMessage.inAppMessageType].filter(message => message.publicId !== seenMessage.publicId);

  const updatedMessageTypes = {
    ...inAppMessagesByType,
    [seenMessage.inAppMessageType]: filteredMessagesForType
  };

  return updatedMessageTypes;
};

export default {
  shouldShowMessage,
  formatInAppMessages,
  filterInAppMessages
};
